export const titleCase = (str = '') => {
    if (!str || typeof str !== 'string') return str;
    return str.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

export const demangle = (title = '') => {
    if (!title) {
        return '';
    }
    // "Hunger Games, The" -> "The Hunger Games"
    var articles = ['The', 'An', 'A'];
    var fragments = title.split(': ');
    // accounts for "Shell Game, The: A Fox and O'Hare Short Story"
    fragments.forEach((fragment, i) => {
        articles.forEach((article) => {
            var splitIndex = (article.length + 2) * -1; // +2 adds room for ", " — negative means start from the end of the string
            if (fragment.slice(splitIndex) === ', ' + article) {
                var newFragment = article + ' ' + fragment.slice(0, splitIndex);
                fragments[i] = newFragment;
            }
        });
    });
    return fragments.join(': ');
};

export const sorts = {
    asc(a, b) {
        let at = typeof a === 'string' ? a.toLowerCase() : a;
        let bt = typeof b === 'string' ? b.toLowerCase() : b;
        if (at < bt) {
            return -1;
        } else if (at > bt) {
            return 1;
        } else {
            return 0;
        }
    },
    desc(a, b) {
        let at = typeof a === 'string' ? a.toLowerCase() : a;
        let bt = typeof b === 'string' ? b.toLowerCase() : b;
        if (at > bt) {
            return -1;
        } else if (at < bt) {
            return 1;
        } else {
            return 0;
        }
    }
};

export const isShowURI = (uri: string) => {
    const regex = /spotify:show:([a-z0-9A-Z]{22})/gm;
    return regex.test(uri);
};

export const parseSpotifyUri = (uri) => {
    const [, type, id] = uri.match(/spotify:(\w+):(\w+)/);
    return { type, id };
};

// Publisher rename: Gateway is an internal ops surface, so it shows BOTH names --
// ops need to reconcile the public name against the record identity. Conditional
// on purpose: no publisher has a display name until one is set in TRAP, so an
// unconditional layout would put a redundant duplicate on every row in the catalog.
//
//   display absent  -> "Acme Publishing"                (identical to today)
//   display present -> "Acme Publishing (Acme Audio)"
//
// Canonical leads and the display name is always the one in parentheses. Keeping
// the parenthesised slot to a single meaning is what stops the two names being
// mistaken for each other at a glance.
//
// Never use this for a search query or a sort key -- those stay on canonical
// publisherName, or internal search silently stops finding the publisher's titles.
export const publisherLabel = (canonical, display) => {
    const name = canonical || '';
    const shown = typeof display === 'string' ? display.trim() : '';
    if (!shown || shown === name) return name;
    return name ? `${name} (${shown})` : shown;
};
